<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div style="display: flex; padding-top: 25px; height: 80px; align-items: center; margin: auto 0 auto 23px;">
    <div style="margin: auto 0;">
      <mat-form-field appearance="outline" style="margin: 0 5px auto 0;">
        <mat-label>Select</mat-label>
        <mat-select [(ngModel)]="selectedLevel">
          <mat-option *ngFor="let level of selectLevelList" [value]="level">{{level}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="select-all-button-wrapper">
      <button mat-stroked-button (click)="setProtectionLevel('none')">None</button>
      <button mat-stroked-button (click)="setProtectionLevel('medium')">Dynamic</button>
      <button mat-stroked-button (click)="setProtectionLevel('high')">Always On</button>
    </div>
    <div class="button-col" tabindex="0">
        <button mat-stroked-button color="primary" class="reset-button" (click)="onSetRecommendedClick()"
            aria-label="Set to Recommended button can be enabled or disabled by changing the 'Always On' file type protection from the Settings tab.">
            {{'RECOMMENDED_BUTTON' | translate}}
        </button>
    </div>
</div>
<div class="policy-extension-wrapper">
    <div class="policy-extension-col">
        <div class="control-group-row">
            <mat-slide-toggle *ngIf="showEnabledButton"
                id="microsoft-office-toggle"
                color="primary"
                disableRipple="true"
                [checked]="policyEnabled"
                [matTooltip]="getToggleTooltip()"
                matTooltipShowDelay="350"
                matTooltipPosition="right"
                (change)="onToggleEnableChange($event)">
                    {{policyEnabled ? 'Enabled' : 'Disabled'}}
            </mat-slide-toggle>
        </div>
        <span *ngFor="let fileFormat of fileFormats; let i = index;">
            <h2 id="{{fileFormat.name | replaceSpace: '-' | lowercase}}" [ngClass]="{'policy-enabled': policyEnabled, 'policy-disabled': !policyEnabled}">
                <span class="default-icon">
                    <span class="{{fileFormat.icon}}"></span>
                </span>
                {{fileFormat.name}}
            </h2>
            <span *ngIf="i === 0" [ngClass]="{'protection-level-title': policyEnabled, 'protection-level-title-disabled': !policyEnabled}">
                {{'PROTECTION_LEVEL' | translate}}
                <span role="application" class="fa-layers fa-fw" (keyup.enter)="onProtectionLevelClick()" (click)="onProtectionLevelClick()"
                    [ngClass]="{'clickable question-icon': policyEnabled, 'clickable-disabled question-icon-disabled': !policyEnabled}">
                    <span tabindex="0" aria-label="Protection level explanation. Click the enter key to select." class="mdi mdi-help-circle-outline"></span>
                </span>
            </span>
            <div *ngFor="let ext of fileFormat.extensions;" class="ext-row">
                <span id="label-{{fileFormat.name | replaceSpace: '-' | lowercase}}-{{ext.extension}}" attr.aria-label="{{getAriaLabel(ext.extension)}}" [ngClass]="{'policy-enabled': policyEnabled, 'policy-disabled': !policyEnabled}" class="ext-label">{{ext.extension}}</span>
                <span class="policy-toggle-button-group">
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" attr.aria-labelledby="{{fileFormat.name | replaceSpace: '-' | lowercase}} label-{{fileFormat.name | replaceSpace: '-' | lowercase}}-{{ext.extension}}" value="{{fileFormat.name | replaceSpace: '-' | lowercase}}:{{ext.extension | lowercase}}:{{ext.value}}" (change)=onToggleSettingChanged($event) [appearance]="toggleGroupAppearance">
                        <mat-button-toggle color="primary" id="{{fileFormat.name | replaceSpace: '-' | lowercase}}:{{ext.extension | lowercase}}:none" value="{{fileFormat.name | replaceSpace: '-' | lowercase}}:{{ext.extension | lowercase}}:none" disableRipple="true" [checked]="true">{{'NONE' | translate}}</mat-button-toggle>
                        <mat-button-toggle color="primary" id="{{fileFormat.name | replaceSpace: '-' | lowercase}}:{{ext.extension | lowercase}}:medium" value="{{fileFormat.name | replaceSpace: '-' | lowercase}}:{{ext.extension | lowercase}}:medium" disableRipple="true">Dynamic</mat-button-toggle>
                        <mat-button-toggle color="primary" id="{{fileFormat.name | replaceSpace: '-' | lowercase}}:{{ext.extension | lowercase}}:high" value="{{fileFormat.name | replaceSpace: '-' | lowercase}}:{{ext.extension | lowercase}}:high" [disabled]="!allowAlwaysOn" disableRipple="true">Always on</mat-button-toggle>
                    </mat-button-toggle-group>
                </span>
            </div>
        </span>
    </div>
</div>
